export default __webpack_public_path__ + "static/media/DE-Logo-white.d768fed0.png";